import { render, staticRenderFns } from "./Map2DAsEditableContentComponent.vue?vue&type=template&id=0ff18367&scoped=true&"
import script from "./Map2DAsEditableContentComponent.vue?vue&type=script&lang=js&"
export * from "./Map2DAsEditableContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff18367",
  null
  
)

export default component.exports